module.exports = __webpack_public_path__ + "static/media/btn_android_cn.7b9e9932.svg";